var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Top"),
      _vm._v(" "),
      _c("div", { staticClass: "container container--mobile" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("Pagination", {
                attrs: { numberOfDots: 4, numberOfVisitedDots: 2 }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "margin-top-75" }),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("p", [_vm._v("Fyll i koden du fick med SMS.")]),
              _vm._v(" "),
              _c("p", [
                _vm._v("Fick du ingen kod? Gå tillbaka och kontrollera numret.")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.phoneCode,
                    expression: "phoneCode"
                  }
                ],
                staticClass: "form-control form-control-lg",
                attrs: {
                  type: "text",
                  placeholder: "Skriv in kod",
                  maxlength: _vm.codeLength
                },
                domProps: { value: _vm.phoneCode },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.phoneCode = $event.target.value
                    },
                    function($event) {
                      return _vm.enforceNumbers()
                    }
                  ],
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.codeEntered()
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("alert", [_vm._v("Något gick fel, vänligen försök igen!")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-lg btn-block",
                  attrs: { disabled: !_vm.isCodeLengthValid },
                  on: {
                    click: function($event) {
                      return _vm.codeEntered()
                    }
                  }
                },
                [_vm._v("Nästa")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-dark btn-lg btn-block",
                  on: {
                    click: function($event) {
                      return _vm.$router.go(-1)
                    }
                  }
                },
                [_vm._v("← Tillbaka")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm" })
        ])
      ]),
      _vm._v(" "),
      _c("Alert"),
      _vm._v(" "),
      _c("Bottom")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-wrapper" }, [
      _c("h4", { staticClass: "text-left text-primary-fh" }, [
        _vm._v("Skriv in koden")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29180b36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29180b36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EnterCode.vue
// module id = null
// module chunks = 